import { nullishToOptional } from "../helpers";
import { z } from "zod";
export const PublishedDocPageVisitsEntry = z.object({
    id: z.string(),
    versionId: z.string(),
    pagePersistentId: z.string(),
    locale: z.string().optional(),
    timestamp: z.coerce.date(),
    visits: z.number(),
    userId: nullishToOptional(z.string()),
    anonymousId: nullishToOptional(z.string()),
    ipAddress: nullishToOptional(z.string()),
});
